import YFormEditor from './Editor';

export { YFormEditor };
export default YFormEditor;
